import SpriteSymbol from "../../../../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "print",
  "use": "print-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"print\"><g fill=\"none\" fill-rule=\"evenodd\"><path /><path fill=\"var(--bolt-theme-icon, currentColor)\" d=\"M21 16c0 .6-.4 1-1 1h-1v-3c0-.6-.4-1-1-1H6a1 1 0 00-1 1v3H4a1 1 0 01-1-1v-5c0-.6.5-1 1-1h16c.6 0 1 .4 1 1v5zM7 21h10v-6H7v6zM7 8h10V3H7v5zm13 0h-1V2c0-.6-.4-1-1-1H6a1 1 0 00-1 1v6H4a3 3 0 00-3 3v5a3 3 0 003 3h1v3c0 .6.5 1 1 1h12c.6 0 1-.4 1-1v-3h1a3 3 0 003-3v-5a3 3 0 00-3-3z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol